<template>
  <div v-loading="loading" style="width:100%;height:100%;overflow-y:auto;background:#f6f6f6;padding:10px">
    <!-- 顶部指标卡片 -->
    <div style="display:flex;gap:10px;flex-wrap:wrap">
      <div class="card" style="flex:1;min-width:200px" v-for="item in topCards" :key="item.label"
        :class="{ drillable: item.drill }" @click="item.drill && item.drill()">
        <div style="font-size:12px;color:#999">{{ item.label }}</div>
        <div :style="{fontSize:'24px',fontWeight:600,color:item.color||'#333',marginTop:'8px'}">
          {{ item.value }}<text style="font-size:12px" v-if="item.suffix">{{ item.suffix }}</text>
        </div>
        <div style="font-size:11px;color:#bbb;margin-top:4px">{{ item.sub }}</div>
      </div>
    </div>

    <!-- 应收应付概览 -->
    <div style="display:flex;gap:10px;margin-top:10px">
      <div class="card" style="flex:1">
        <div style="font-size:14px;font-weight:600;margin-bottom:12px">应收款</div>
        <div style="display:flex;gap:20px">
          <div style="flex:1">
            <div style="font-size:12px;color:#999">商品订单应收</div>
            <div class="drill-value" @click="goSpDetail('month')">{{ data.spYsje }}<text style="font-size:12px">￥</text></div>
          </div>
          <div style="flex:1">
            <div style="font-size:12px;color:#999">商品实到(累计)</div>
            <div class="drill-value" @click="goSpDetail('year')">{{ data.spSjTotal }}<text style="font-size:12px">￥</text></div>
            <div style="font-size:11px;color:#bbb;margin-top:4px">手续费 {{ data.spSxfTotal }}￥ · 分销返佣 {{ data.spFxTotal }}￥</div>
          </div>
          <div style="flex:1">
            <div style="font-size:12px;color:#999">旅游订单应收</div>
            <div style="font-size:18px;font-weight:600;color:#e6a23c;margin-top:4px">{{ data.lyYsje }}<text style="font-size:12px">￥</text></div>
          </div>
          <div style="flex:1">
            <div style="font-size:12px;color:#999">到账待认领</div>
            <div style="font-size:18px;font-weight:600;color:#409eff;margin-top:4px">{{ data.dzgsWrl }}<text style="font-size:12px">￥</text></div>
          </div>
        </div>
      </div>
      <div class="card" style="flex:1">
        <div style="font-size:14px;font-weight:600;margin-bottom:12px">应付款</div>
        <div style="display:flex;gap:20px">
          <div style="flex:1">
            <div style="font-size:12px;color:#999">对账单待付</div>
            <div style="font-size:18px;font-weight:600;color:#f56c6c;margin-top:4px">{{ data.dzdDfk }}<text style="font-size:12px">￥</text></div>
          </div>
          <div style="flex:1">
            <div style="font-size:12px;color:#999">旅游采购欠款</div>
            <div style="font-size:18px;font-weight:600;color:#f56c6c;margin-top:4px">{{ data.lyCgQk }}<text style="font-size:12px">￥</text></div>
          </div>
          <div style="flex:1">
            <div style="font-size:12px;color:#999">对账单总数</div>
            <div style="font-size:18px;font-weight:600;color:#333;margin-top:4px">{{ data.dzdTotal }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 收入趋势 -->
    <div class="card" style="margin-top:10px">
      <div style="font-size:14px;font-weight:600;margin-bottom:12px">近6月收入趋势</div>
      <el-table :data="trendData" style="width:100%" size="small">
        <el-table-column label="月份" prop="month" width="120" align="center" />
        <el-table-column label="商品收入" prop="spJe" align="right">
          <template #default="{ row }">
            <el-link type="primary" @click="goSpDetail('month', row.month)">{{ row.spJe }}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="旅游收入" prop="lyJe" align="right" />
        <el-table-column label="合计" prop="total" align="right">
          <template #default="{ row }">
            <span style="font-weight:600">{{ row.total }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref, computed } from "vue";
import { caiwu_dashboard } from "@/http/api";
import store from "@/store";
import dayjs from "dayjs";

export default {
  setup() {
    const loading = ref(false);

    const data = reactive({
      spToday: "0", spMonth: "0", spYear: "0", spTotal: "0", spYsje: "0",
      spSxfToday: "0", spSxfMonth: "0", spSxfYear: "0", spSxfTotal: "0",
      spFxToday: "0", spFxMonth: "0", spFxYear: "0", spFxTotal: "0",
      spSjToday: "0", spSjMonth: "0", spSjYear: "0", spSjTotal: "0",
      lyToday: "0", lyMonth: "0", lyYear: "0", lyTotal: "0", lyYsje: "0",
      lyCgTotal: "0", lyCgYf: "0", lyCgQk: "0", spJsCb: "0",
      dzdTotal: 0, dzdDfk: "0", dzdYfk: "0",
      dzgsTotal: "0", dzgsYrl: "0", dzgsWrl: "0",
      spTrend: [], lyTrend: [],
    });

    // 穿透到商品订单明细
    const goSpDetail = (type, monthStr) => {
      let startDate, endDate;
      const now = dayjs();
      if (type === 'today') {
        startDate = now.format('YYYY-MM-DD');
        endDate = now.format('YYYY-MM-DD');
      } else if (type === 'year') {
        startDate = now.startOf('year').format('YYYY-MM-DD');
        endDate = now.format('YYYY-MM-DD');
      } else if (type === 'month' && monthStr) {
        // monthStr 格式为 YYYY-MM
        const m = dayjs(monthStr + '-01');
        startDate = m.startOf('month').format('YYYY-MM-DD');
        endDate = m.endOf('month').format('YYYY-MM-DD');
      } else {
        // 默认本月
        startDate = now.startOf('month').format('YYYY-MM-DD');
        endDate = now.endOf('month').format('YYYY-MM-DD');
      }
      store.commit('openMenu', {
        path: 'CaiWuSpddMingXi',
        title: '商品订单明细',
        data: { startDate, endDate },
        refresh: true,
      });
    };

    const topCards = computed(() => [
      { label: "今日商品收入", value: data.spToday, suffix: "￥", color: "#e6a23c", sub: `本月 ${data.spMonth}￥ | 实到 ${data.spSjToday}￥`, drill: () => goSpDetail('today') },
      { label: "今日旅游收入", value: data.lyToday, suffix: "￥", color: "#409eff", sub: `本月 ${data.lyMonth}￥` },
      { label: "本年商品总收入", value: data.spYear, suffix: "￥", color: "#67c23a", sub: `累计 ${data.spTotal}￥ | 手续费 ${data.spSxfYear}￥ | 分销 ${data.spFxYear}￥`, drill: () => goSpDetail('year') },
      { label: "本年旅游总收入", value: data.lyYear, suffix: "￥", color: "#909399", sub: `累计 ${data.lyTotal}￥` },
    ]);

    const trendData = computed(() => {
      const map = {};
      (data.spTrend || []).forEach(i => {
        const k = `${i.Year}-${String(i.Month).padStart(2, "0")}`;
        map[k] = { sp: i.Je, ly: 0 };
      });
      (data.lyTrend || []).forEach(i => {
        const k = `${i.Year}-${String(i.Month).padStart(2, "0")}`;
        if (map[k]) map[k].ly = i.Je;
        else map[k] = { sp: 0, ly: i.Je };
      });
      return Object.entries(map)
        .sort(([a], [b]) => a.localeCompare(b))
        .map(([k, v]) => ({
          month: k,
          spJe: Number(v.sp).toFixed(2),
          lyJe: Number(v.ly).toFixed(2),
          total: Number(v.sp + v.ly).toFixed(2),
        }));
    });

    onMounted(() => {
      loading.value = true;
      caiwu_dashboard().then(res => {
        if (res.status == 200) Object.assign(data, res.data);
      }).finally(() => {
        loading.value = false;
      });
    });

    return { data, topCards, trendData, loading, goSpDetail };
  },
};
</script>

<style scoped>
.card {
  background: #fff;
  border-radius: 7px;
  padding: 20px;
}
.drillable {
  cursor: pointer;
  transition: box-shadow 0.2s;
}
.drillable:hover {
  box-shadow: 0 2px 8px rgba(0,0,0,0.12);
}
.drill-value {
  font-size: 18px;
  font-weight: 600;
  color: #e6a23c;
  margin-top: 4px;
  cursor: pointer;
}
.drill-value:hover {
  text-decoration: underline;
}
</style>
